(() => {
  try {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], () => {});
    }
  } catch {}
  const viewing = document.getElementById('hartfield-viewing-context');
  if (viewing) {
    const query = new URLSearchParams(location.search);
    const handle = query.get('piece'), name = query.get('viewing');
    if (/^[a-z0-9][a-z0-9-]{0,199}$/.test(handle || '') && name && name.length <= 500) {
      viewing.textContent = viewing.dataset.prefix + ' ' + name + '. ' + viewing.dataset.note;
      viewing.hidden = false;
    }
  }
  const emit = (action, handle) => {
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof window.gtag !== 'function') return;
      const params = {send_to:'G-CGN2QT8MZV',page_location:location.origin + location.pathname,page_referrer:document.referrer ? new URL(document.referrer).origin : ''};
      if (/^[a-z0-9][a-z0-9-]{0,199}$/.test(handle || '')) params.item_handle = handle;
      window.gtag('event', 'hartfield_' + action, params);
    } catch {}
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    const action = link.dataset.hartfieldAction;
    if (['viewing_start','calendar_open','calendar_external'].includes(action)) { emit(action, link.dataset.pieceHandle); return; }
    try {
      const url = new URL(link.href);
      if (url.origin === location.origin && url.pathname === '/pages/by-appointment') emit('booking_start');
      else if (url.protocol === 'mailto:' && link.closest('.hartfield-piece-enquiry')) emit('enquiry_click');
    } catch {}
  });
  const calendar = document.getElementById('appointment-calendar');
  if (calendar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { emit('calendar_view'); observer.disconnect(); }
    }, {threshold:0.25});
    observer.observe(calendar);
  }
})();
